import React, {
  useEffect,
  useRef,
  useState,
} from 'react';

import DoneIcon from 'assets/images/icon/DoneIcon';
import FileIcon from 'assets/images/icon/FileIcon';
import FileRemoveIcon from 'assets/images/icon/FileRemoveIcon';
import PlusIconDark from 'assets/images/icon/PlusIconDark';
import axios from 'axios';
import {
  cloneDeep,
  isEmpty,
} from 'lodash';
import {
  useLocation,
  useNavigate,
} from 'react-router-dom';
import styled from 'styled-components';

const MembersStep3 = (props) => {
    const fileInputRef = useRef(null);
    const location = useLocation();
    const navigate = useNavigate();
    const [fileTitle, setFileTitle] = useState("");
    const [renderItem, setRenderItem] = useState(false);
    const [qualification1, setQualification1] = useState("");
    const [qualification2, setQualification2] = useState("");
    const [qualification3, setQualification3] = useState("");
    const [agreement, setAgreeMent] = useState(false);

    const getFormData = () => {
        const step1 = cloneDeep(location?.state?.step1);
        const step2 = cloneDeep(location?.state?.step2);
        const data = {
            ...step1,
            category: cloneDeep(step2),
            qualification1: qualification1,
            qualification2: qualification2,
            qualification3: qualification3,
        };
        const blogURL = {
            linkedin: data["blogUrl.linkedin"],
            twitter: data["blogUrl.twitter"],
            website: data["blogUrl.website"],
        };
        console.log("data", data);
        const resumeFile = fileInputRef?.current?.files?.[0];
        const formData = new FormData();

        let obj = {};
        const c = cloneDeep(location?.state?.step2);
        c.forEach((item) => {
            if (isEmpty(obj[item?.category])) {
                obj[item?.category] = [];
            }
            obj[item?.category].push(item?.subCategory);
        });
        formData.append("blogUrl", JSON.stringify(cloneDeep(blogURL)));
        formData.append("email", data.email);
        formData.append("category", JSON.stringify(cloneDeep(obj)));
        formData.append("firstName", data.firstName);
        formData.append("jobTitle", data.jobTitle);
        formData.append("lastName", data.lastName);
        formData.append("password", data.password);
        formData.append("qualification1", data.qualification1);
        formData.append("qualification2", data.qualification2);
        formData.append("qualification3", data.qualification3);
        formData.append("resumeFile", resumeFile);
        return formData;
    };
    const onChange = (setState, value) => {
        setState(value);
    };
    const handleAddSyllabusFile = (e) => {
        const file = fileInputRef?.current?.files?.[0];
        setFileTitle(file?.name);
        console.log("file", file);
    };
    const signUpInstructor = async () => {
        await axios({
            url: "https://api-office.whoflex.com/teachers",
            method: "post",
            data: getFormData(),
        }).then((res) => {
            console.log("signUp", res);
        });
    };

    const onClickNavigate = (path) => {
        navigate(path, {
            state: {
                step1: cloneDeep(location?.state?.step1),
                step2: cloneDeep(location?.state?.step2),
                step3: {
                    qualification1: qualification1,
                    qualification2: qualification2,
                    qualification3: qualification3,
                },
            },
        });
    };

    const handleDownload = (fileUrl) => {
        // Create a link element
        const link = document.createElement('a');
        link.href = fileUrl;
        link.target = '_blank';
        link.download = "resume";
    
        // Simulate a click on the link to trigger the download
        link.click();
      };

    useEffect(() => {
        if (!isEmpty(location?.state?.step3)) {
            setQualification1(location?.state?.step3?.qualification1);
            setQualification2(location?.state?.step3?.qualification2);
            setQualification3(location?.state?.step3?.qualification3);
        }
    }, [location?.state?.step3]);


    useEffect(() => {
        if (!isEmpty(location?.state?.step2)) {
            let obj = {};
            const c = cloneDeep(location?.state?.step2);
            c.forEach((item) => {
                if (isEmpty(obj[item?.category])) {
                    obj[item?.category] = [];
                }
                obj[item?.category].push(item.subCategory);
            });

            console.log("c", obj);
        }
    }, []);

    useEffect(()=>{
        setTimeout(() => {
        setRenderItem(true)            
        }, 200);
    },[])

    console.log('props', props)

    return (
        <Container
        className={renderItem ? "on" : ""}
        onSubmit={(e)=>{
            e.preventDefault();
         }}>
            <SubTitle>
                <h2>3. Qualifications</h2>
                <span>Required fields *</span>
            </SubTitle>
            <Contents>
                <TextAreaItem>
                    <h4>
                        Are there any other topics not listed here that you are qualified to teach
                        or to coach? (1000 character limit)
                    </h4>
                    <textarea
                        value={props?.data?.qualification?.answer1}
                        onChange={(e) => {
                         
                        }}
                    />
                </TextAreaItem>
                <TextAreaItem>
                    <h4>
                        Please tell us about classes or coaching you’d like to offer at Whoflex
                        (2000 character limit)*
                    </h4>
                    <textarea
                       value={props?.data?.qualification?.answer2}
                        onChange={(e) => {
                           
                        }}
                        required={true}
                    />
                </TextAreaItem>
                <TextAreaItem>
                    <h4>
                        Share a link to one of your videos which may help us to review your Whoflex
                        application. (2000 character limit)
                    </h4>
                    <textarea
                         value={props?.data?.qualification?.answer3}
                        onChange={(e) => {
                           
                        }}
                    />
                </TextAreaItem>
                <InputArea>
                    <h4>Please Upload Your Resume Here</h4>
                    <InputContents>
                      
                        {fileInputRef?.current?.files?.[0] && fileTitle !== "" ? (
                            <InputIcons
                                className="on"
                                style={{
                                    justifyContent: "space-between",
                                }}
                            >
                                <div>
                                    <FileIcon />
                                    <span style={{ marginLeft: 18 }}>{fileTitle}</span>
                                </div>
                                <div>
                                    <RemoveButton
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setFileTitle("");
                                            fileInputRef.current.value = "";
                                        }}
                                    >
                                        <FileRemoveIcon />
                                    </RemoveButton>
                                    <DoneIcon />
                                </div>
                            </InputIcons>
                        ) : (
                            <InputIcons
                                onClick={()=>{
                                    handleDownload(props?.data?.qualification?.resumeFileUrl)
                                }}
                            >
                                <PlusIconDark/>
                                <p>Resume File</p>
                            </InputIcons>
                        )}
                    </InputContents>
                </InputArea>
             
            </Contents>
            <Btns>
                <Next>
                    <span
                        onClick={() => {
                           props?.onClickPrev()
                        }}
                        style={{ background: "#000" }}
                    >
                        PREVIOUS
                    </span>
                </Next>
               
            </Btns>
        </Container>
    );
};
export default MembersStep3;

const Container = styled.form`
    display: block;
    transform: translateX(-50px);
    transition: all 0.2s;
    opacity: 0;
    &.on{
        opacity: 1;
        transform: none;
    }
    p {
        font-family: Arial;
        font-weight: 400;
        font-size: 14px;
        color: #666;
        line-height: 21px;
    }
`;
const SubTitle = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 17px;
    h2 {
        font-size: 20px;
        font-weight: 400;
        font-weight: 400;
        color: #333;
    }
    span {
        display: flex;
        color: #666;
        font-size: 12px;
    }
`;

const Btns = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    & > div {
        width: calc((100% - 8px) / 2);
    }
`;
const Next = styled.div`
    span,
    button {
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: Arial;
        font-weight: 700;
        font-size: 15px;
        text-align: center;
        text-transform: uppercase;
        color: #fff;
        background: #ddd;
        &.on {
            background: #e0c463;
        }
        border-radius: 5px;
        width: 100%;
        -webkit-transition: all 0.3s ease-in-out;
        transition: all 0.3s ease-in-out;
        border: 0;
        padding: 17.5px 12px;
        cursor: pointer;
        box-sizing: border-box;
        appearance: none;
        line-height: 1;
    }
`;
const Contents = styled.div``;
const TextAreaItem = styled.div`
    margin-bottom: 20px;
    h4 {
        margin-bottom: 5px;
        line-height: 21px;
        font-size: 14px;
        font-weight: 500;
    }
    textarea {
        resize: none;
        border: 1px solid #ddd;
        font-family: Arial;
        line-height: 21px;
        background: #fff;
        padding: 8px 15px 23px;
        font-size: 14px;
        border-radius: 10px;
        width: 100%;
        height: 140px;
        &:focus {
            outline: 1.5px solid #e0c463;
            &.warn {
                outline: #ea4335 solid 1px;
            }
        }
    }
`;
const InputArea = styled.div`
    margin-bottom: 27px;
    h4 {
        font-size: 14px;
        line-height: 21px;
        font-weight: 400;
        margin-bottom: 5px;
    }
`;
const InputContents = styled.div`
    cursor: pointer;
    position: relative;
    height: 62px;
    width: 100%;
    border: 1px solid #ddd;
    color: #e0c463;
    border-radius: 10px;
    input {
        cursor: pointer;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        position: absolute;
        z-index: 9;
        opacity: 0;
    }
`;
const InputIcons = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    justify-content: center;

    margin-bottom: 11px;
    padding: 0 20px;
    border-radius: 10px;
    &.on {
        background-color: #eff3fe;
        border: 2px solid #276ef1;
    }
    & > div {
        display: flex;
        align-items: center;
        .remove_svg_icon {
        }
        svg {
            &:nth-child(1) {
            }
        }
    }
    p {
        margin-left: 18px;
        font-size: 16px;
        font-weight: 700;
        color: #e0c463;
    }
    span {
        font-weight: 400;
        font-size: 17px;
        line-height: 21px;
        color: #111;
    }
`;
const InputEdit = styled.div``;
const Desc = styled.div`
    margin-bottom: 22px;
    p {
        font-size: 14px;
        font-weight: 400;
        a {
            display: inline-block;
            font-family: Arial;
            font-weight: 700;
            font-size: 14px;
            color: #e0c463;
            text-decoration: none;
        }
    }
`;
const Agreement = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 22px;
    p {
        font-size: 14px;
        font-weight: 400;
        a {
            display: inline-block;
            font-family: Arial;
            font-weight: 700;
            font-size: 14px;
            color: #e0c463;
            text-decoration: none;
        }
    }
`;
const RemoveButton = styled.div`
    height: 100%;
    z-index: 10;
    display: flex;
    align-items: center;
    padding: 10px 18px;
    cursor: pointer;
`;
const CheckBoxWrap = styled.div`
    display: flex;
    align-items: center;
    transition: all 0.2s;
    padding-bottom: 2px;
    margin-right: 13px;
    cursor: pointer;
    &.on {
        transition: all 0.2s;
        svg {
            transform: scale(1.3);
        }
        & > div {
            transition: all 0.2s;
            border: solid 1px #000;
            background: #000;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
    span {
        padding-top: 2px;
        font-size: 16px;
        color: #212529;
    }
    div {
        width: 25px;
        height: 25px;
        border-radius: 4px;
        border: solid 1px rgba(51, 51, 51, 0.3);
    }
`;
